import React from 'react'
import { Tooltip } from '@mui/material'

type TooltipTextProps = {
  title: string | React.ReactElement | React.ReactNode
  disableInteractive?: boolean
  placement?: 'bottom' | 'top' | 'left' | 'right' | 'bottom-start'
  slotProps?: any
  children: React.ReactElement
  arrow?: boolean
  componentsProps?: any
  classes?: any
  disableHoverListener?: boolean
  sx?: any
}

export const CustomTooltip = ({
  title,
  disableInteractive,
  placement,
  slotProps,
  children,
  arrow = false,
  disableHoverListener,
  sx,
  componentsProps = {
    tooltip: {
      sx: {
        padding: '0.25rem 0.75rem',
        fontSize: '0.75rem',
        fontWeight: '500',
        lineHeight: '1.5rem',
        width: 'max-content',
      },
    },
  },
  classes,
}: TooltipTextProps) => {
  return (
    <Tooltip
      disableInteractive={!!disableInteractive}
      placement={placement || 'bottom'}
      slotProps={slotProps ?? {}}
      componentsProps={componentsProps}
      classes={classes}
      disableHoverListener={disableHoverListener}
      sx={sx}
      title={
        <span
          onClick={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
          onMouseDown={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
          onMouseUp={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
        >
          {title}
        </span>
      }
      arrow={arrow}
    >
      {children}
    </Tooltip>
  )
}
